import { NBRAdviserImportDTO } from '@core/pages/new-business-register/api'

export class AdviserImport implements NBRAdviserImportDTO {
  fullname: string;
  companyCode: string;
}
